define('CookiesUtilities', [], function CookiesUtilities() {
    'use strict';

    // -------------------------------------------------------------------------------------------------
    // Section: Utilities
    // -------------------------------------------------------------------------------------------------
    return {
        setCookie: function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            var expires;
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        },

        getCookie: function getCookie(cname) {
            var name = cname + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            var i;
            var c;
            for (i = 0; i < ca.length; i++) {
                c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
    };
    // -------------------------------------------------------------------------------------------------
});
